import classNames from "classnames";
import Color from "color";
import { Moment } from "moment";
import BookingPill from "PFApp/components/pills/booking_pill";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import CutIcon from "PFIcons/cut.svg";
import React, { useMemo } from "react";

import cssBars from "../../../bars.module.scss";
import { useBookingBarContext } from "../../booking_bar_provider";
import css from "./split_booking_visualisation.module.scss";

interface SplitBookingVisualisationProps {
  startDate: Moment;
  endDate: Moment;
  splitDate: Moment;
}

export const SplitBookingVisualisation = ({
  startDate,
  endDate,
  splitDate
}: SplitBookingVisualisationProps): JSX.Element => {
  const { category } = useBookingBarContext();
  const { utc, formatDate } = useDateFormatter();

  const { leftPillWidthInDays, rightPillWidthInDays, newStartDateRight } = useMemo(
    () => ({
      leftPillWidthInDays: splitDate.diff(startDate, "days") + 1,
      rightPillWidthInDays: endDate.diff(splitDate, "days"),
      newStartDateRight: utc(splitDate).add(1, "day")
    }),
    [startDate, endDate, splitDate, utc]
  );

  return (
    <div className={css.root}>
      <BookingPill
        category={category}
        style={{ flex: leftPillWidthInDays }}
        className={classNames(css.pill, css.leftPill, cssBars.pill, {
          [cssBars.lightCategoryColor]: !category?.color || Color(category.color).isLight()
        })}
      >
        <span>{`${formatDate(startDate)} - ${formatDate(splitDate)}`}</span>
      </BookingPill>
      <div className={css.divider}>
        <CutIcon width={16} height={16} />
      </div>
      <BookingPill
        category={category}
        style={{ flex: rightPillWidthInDays }}
        className={classNames(css.pill, cssBars.pill, {
          [cssBars.lightCategoryColor]: !category?.color || Color(category.color).isLight()
        })}
      >
        <span>{`${formatDate(newStartDateRight)} - ${formatDate(endDate)}`}</span>
      </BookingPill>
    </div>
  );
};
